import React from 'react'
import { isAndroid, throttle } from '../../utils/limit'
import './index.scss'
import { getElementTop } from '../../utils/utils'
export interface ITabsProps {
  config: any
}

export interface IAchorTabsState {
  showTabContList: boolean
  offsets?: any
  scrlH: number
  activeIndex: number
  ratio: number
}
interface IAnchorTabsProps {
  config: any
}

let screenHeight
let timer
class AnchorTabs extends React.Component<
  IAnchorTabsProps & any,
  IAchorTabsState
> {
  private tabRef
  public containerRef
  constructor(props: IAnchorTabsProps) {
    super(props)
    this.state = {
      showTabContList: false,
      offsets: [],
      scrlH: 0,
      activeIndex: 0,
      ratio: 2,
    }
    // tslint:disable-next-line: unnecessary-bind
    this.onScroll = throttle(this.onScroll.bind(this), 500)
    this.tabRef = React.createRef<HTMLDivElement>()
    this.containerRef = React.createRef<HTMLDivElement>()
  }
  // static getDerivedStateFromProps(nextProps, prevState) {
  //   if (prevState.config !== nextProps.config) {
  //     return {
  //       ...prevState,
  //       activeIndex: nextProps.config.activeIndex,
  //     }
  //   }
  // }

  public componentDidMount() {
    const screenWidth = document.querySelector('.pageContent').clientWidth
    const ratio = screenWidth / 750
    const { config, id } = this.props
    const { tabs } = config
    const scrollApp = this.tabRef.current
    screenHeight = document.body.clientHeight
    this.setState({
      scrlH: scrollApp ? scrollApp.getBoundingClientRect().top : 0,
      ratio,
    })
    const pageContent = document.querySelector('.pageContent')
    // tslint:disable-next-line:no-unused-expression
    if (!pageContent) {
      return
    }
    pageContent.addEventListener('scroll', this.onScroll, { passive: true })
    const arr: Array<number | null> = []
    timer = setTimeout(() => {
      tabs &&
        tabs.length > 0 &&
        tabs.forEach((_: any, index: any) => {
          const ele: HTMLElement | null = document.querySelector(
            `.${id}_${index}`
          ) as HTMLElement
          const eleHeigth = ele.offsetTop
          arr.push(eleHeigth)
        })
      this.setState({
        offsets: arr,
      })
    }, 3000)
  }
  public componentWillUnmount() {
    const pageContent = document.querySelector('.pageContent')
    pageContent.removeEventListener('scroll', this.onScroll)
    clearTimeout(timer)
  }
  public onScroll = () => {
    const st = document.querySelector('.pageContent').scrollTop
    const categories = this.tabRef.current
    const tabContainer = this.containerRef.current
    const { offsets } = this.state
    offsets.forEach((offset, index) => {
      if (index !== offsets.length - 1) {
        if (
          st >= offset - screenHeight &&
          st < offsets[index + 1] - screenHeight
        ) {
          this.setState({
            activeIndex: index,
          })
          this.parallelRoll(index)
        }
      } else {
        if (st >= offset - screenHeight) {
          this.setState({
            activeIndex: index,
          })
          this.parallelRoll(index)
        }
      }
    })
    if (st >= getElementTop(tabContainer)) {
      this.addClass()
    } else {
      const node: HTMLElement = this.tabRef.current
      if (node) {
        node.classList.remove(
          this.props.OutLine ? 'tab-box-sticky' : 'tab-box-fixed'
        )
      }
    }
  }

  public addClass = () => {
    const node: HTMLElement = this.tabRef.current
    if (!node) {
      return
    }
    node.classList.add(this.props.OutLine ? 'tab-box-sticky' : 'tab-box-fixed')
  }

  public handleClick = (index: number) => {
    const { activeIndex } = this.state
    const { id } = this.props
    const baseNode: HTMLElement | null = document.querySelector('.pageContent')
    if (!baseNode) {
      return
    }
    baseNode.removeEventListener('scroll', this.onScroll)
    const baseTop = baseNode.getBoundingClientRect().top
    this.addClass()
    const nowAnchorId = document.querySelector(`.${id}_${index}`)
    if (!nowAnchorId) return
    const clickTop =
      nowAnchorId.getBoundingClientRect().top + baseNode.scrollTop
    const nowHeight = clickTop - baseTop - 37
    if (baseNode.scrollTo) {
      baseNode.scrollTo({ top: nowHeight })
    } else {
      nowAnchorId.scrollIntoView()
    }
    this.parallelRoll(index)
    let nowScroll
    let timer = setInterval(() => {
      nowScroll = baseNode.scrollTop
      if (activeIndex < index && nowScroll >= nowHeight) {
        baseNode.addEventListener('scroll', this.onScroll, { passive: true })
        clearInterval(timer)
      }
      if (activeIndex > index && nowScroll <= nowHeight) {
        baseNode.addEventListener('scroll', this.onScroll, { passive: true })
        clearInterval(timer)
      }
    }, 500)
    this.setState({
      activeIndex: index,
    })
  }
  // 左右滚动
  public parallelRoll = (index) => {
    const { ratio } = this.state
    const { config } = this.props
    const multiple = config.tabType === 'img' ? ratio : 1
    const elBlock = document.querySelectorAll('.barItem') as NodeListOf<
      HTMLElement
    >
    const elBox = elBlock[index]
    const elWidth = elBox.clientWidth * multiple
    const offsetLeft = elBox.offsetLeft * multiple
    const screenWidth = document.body.clientWidth
    let totalWidth = 0
    const len = document.querySelectorAll('.barItem').length
    const categories = this.tabRef.current
    if (!categories) return
    if (len > 0) {
      totalWidth = elBlock[len - 1].offsetLeft + elBlock[len - 1].clientWidth
    }
    if (
      screenWidth / 2 < offsetLeft + elWidth / 2 &&
      offsetLeft + elWidth / 2 < totalWidth - screenWidth / 2
    ) {
      // tslint:disable-next-line:radix
      const value: number = parseInt(
        ((offsetLeft + elWidth / 2) / screenWidth).toString()
      )
      let scrollX = 0
      scrollX =
        value * screenWidth +
        (offsetLeft - value * screenWidth) -
        screenWidth / 2 +
        elWidth / 2
      if (!categories.scroll) {
        categories.scrollIntoView()
        return
      }
      categories.scroll(scrollX, 0)
    } else if (screenWidth / 2 >= offsetLeft + elWidth / 2) {
      if (!categories.scroll) {
        categories.scrollIntoView()
        return
      }
      categories.scroll(0, 0)
    } else {
      if (!categories.scroll) {
        categories.scrollIntoView()
        return
      }
      categories.scroll(totalWidth, 0)
    }
  }
  render() {
    const { config, children, id } = this.props
    const { activeIndex, ratio } = this.state
    const placeImg = (
      <img
        alt="tab"
        src="http://haul-cdn-g.bybieyang.com/img/mini/171463d7-5aa2-4ecd-8ab7-d64e54113e78"
      ></img>
    )
    return (
      <div
        ref={this.containerRef}
        className={`lego_tabs_container ${
          config.scrollTab ? '' : 'lego_fullWidth'
        }`}
      >
        <div
          ref={this.tabRef}
          style={{ backgroundColor: config.bgColor }}
          className={`categories ${
            config.tabType === 'img' ? 'imgHeight' : 'textHeight'
          }`}
        >
          {config.tabs &&
            config.tabs.map((item, index: number) => {
              if (config.tabType === 'img') {
                return (
                  <div
                    className={`tabImageBox barItem tabs_anchor_${index}`}
                    style={{ zoom: `${ratio}` }}
                    key={`tabItem${index}`}
                  >
                    {item.tabImage ? (
                      activeIndex === index ? (
                        item['tabImage'][1] ? (
                          <img
                            src={item['tabImage'][1]['url']}
                            alt="tab"
                            onClick={() => this.handleClick(index)}
                          ></img>
                        ) : (
                          placeImg
                        )
                      ) : (
                        <img
                          src={
                            item['tabImage'][0] && item['tabImage'][0]['url']
                          }
                          alt="tab"
                          onClick={() => this.handleClick(index)}
                        />
                      )
                    ) : (
                      placeImg
                    )}
                  </div>
                )
              } else {
                return (
                  <div
                    key={`tabs_name_${index}`}
                    className={
                      activeIndex === index
                        ? `active tabTextItem barItem tabs_anchor_${index}`
                        : `tabTextItem barItem tabs_anchor_${index}`
                    }
                    onClick={() => this.handleClick(index)}
                  >
                    <span
                      className="tabText"
                      style={
                        activeIndex === index
                          ? {
                              backgroundColor: config.activeColor,
                              color: config.textColor,
                            }
                          : { color: config.textColor }
                      }
                    >
                      {item.tabName}
                    </span>
                  </div>
                )
              }
            })}
        </div>
        {config.tabs &&
          config.tabs.map((_, index: number) => {
            return (
              <div className={`${id}_${index}`} key={`${id}_${index}`}>
                {React.Children.map(children, (child: any) => {
                  const { config } = child.props
                  if (config && config.anchor === index) {
                    return child
                  }
                  return null
                })}
              </div>
            )
          })}
      </div>
    )
  }
}

export default AnchorTabs
